<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.003"><path d="M13.602 12.599a.39.39 0 0 1-.238-.081l-2.358-1.768V2.999a1 1 0 0 0-1-1h-5v-1.2a.8.8 0 0 1 .8-.8h7.4a.8.8 0 0 1 .8.8v11.4a.4.4 0 0 1-.404.4z" fill="currentColor"/><path d="m9.362 15.522-3.86-2.895-3.86 2.895a.4.4 0 0 1-.641-.32V3.601a.6.6 0 0 1 .6-.6h7.8a.6.6 0 0 1 .6.6v11.6a.4.4 0 0 1-.4.4.393.393 0 0 1-.239-.079z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-lnb-bookmarks',
});
</script>
